// directives/visibility.ts
import type { DirectiveBinding } from 'vue';

export default {
  mounted(el: HTMLElement, binding: DirectiveBinding<(visible: boolean) => void>) {
    const callback = binding.value;
    if (typeof callback !== 'function') {
      console.warn('v-visibility expects a function as the value');
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          callback(entry.isIntersecting);
        }
      },
      {
        threshold: 0.01,
      }
    );

    observer.observe(el);
    // Store observer on the element so it can be disconnected later
    (el as any).__visibilityObserver__ = observer;
  },

  unmounted(el: HTMLElement) {
    const observer = (el as any).__visibilityObserver__;
    if (observer) {
      observer.disconnect();
      delete (el as any).__visibilityObserver__;
    }
  },
};
